import { Link } from '@tanstack/react-router';
import { Monitor, Smartphone, Tablet } from 'lucide-react';
import { FlagDots } from './flag-dots';
import { formatDuration, relativeTime } from '@/lib/format';
import { Button } from '@/components/ui/button';
import type { Session } from '@pulse/shared';

const DEVICE_ICONS = {
  desktop: Monitor,
  mobile: Smartphone,
  tablet: Tablet,
};

export function SessionRow({ siteId, session }: { siteId: string; session: Session }) {
  const Icon = DEVICE_ICONS[session.device];
  return (
    <tr className="border-b border-border last:border-b-0 hover:bg-bg-surface-2">
      <td className="px-3.5 h-9 align-middle">
        <span className="text-text-subtle font-mono text-xs">vis_</span>
        <span className="font-mono text-xs">{session.visitor_id.replace('vis_', '').slice(0, 6)}</span>
      </td>
      <td className="px-3.5 h-9 align-middle">
        <span className="font-mono text-xs tabular-nums">
          {session.duration_ms != null ? formatDuration(session.duration_ms) : '—'}
        </span>
      </td>
      <td className="px-3.5 h-9 align-middle">
        <span className="font-mono text-xs">{session.pages_viewed}</span>
      </td>
      <td className="px-3.5 h-9 align-middle">
        <span className="font-mono text-xs">{session.entry_url}</span>
      </td>
      <td className="px-3.5 h-9 align-middle">
        <span className="inline-flex items-center gap-1.5 text-text-muted text-xs">
          <Icon className="size-3" />
          {session.device}
        </span>
      </td>
      <td className="px-3.5 h-9 align-middle text-xs">{session.country}</td>
      <td className="px-3.5 h-9 align-middle">
        <FlagDots flags={session.flags} />
      </td>
      <td className="px-3.5 h-9 align-middle">
        <span className="font-mono text-text-muted text-xs">{relativeTime(session.started_at)}</span>
      </td>
      <td className="px-3.5 h-9 align-middle">
        <Button asChild variant="ghost" size="sm" className="h-7 px-2 text-xs">
          <Link to="/sites/$siteId/sessions/$sessionId" params={{ siteId, sessionId: session.id }}>
            Replay
          </Link>
        </Button>
      </td>
    </tr>
  );
}
